import AppUrls from 'app/constants/AppUrls';
import SoundController from 'app/controller/SoundController';
import AspectController from 'app/controller/AspectController';
import { GAME_DIV_ID, GAME_HEIGHT_DEFAULT, GAME_WIDTH_DEFAULT } from 'app/constants/AppConstants';
import { STATE_BOOT, STATE_MAP } from 'app/constants/StateConstants';
import { Debugger } from 'springroll';
import { GAME_BACKGROUND_COLOR } from './app/constants/AppConstants';
import { getDeviceMetric } from './utils/deviceDetection';
import { CaptionsPlugin } from './plugins/springroll/CaptionsPlugin';

const getRendererType = () => {
  if (/webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    // return Phaser.CANVAS;
  }
  return Phaser.AUTO;
};

export default class App {
  /*
   * store initial captionsMuted state in app as the subscribe is firing
   * before we initialise the CaptionsPlugin. This is passed through as initial
   * state to the CaptionsPlugin
   */
  set captionsMuted(val) {
    this._captionsMuted = val;
  }
  get captionsMuted() {
    return this._captionsMuted;
  }

  init(springRollApplication) {
    const appShell = this;

    // Create a new Phaser game object and its initial state.
    this.game = new Phaser.Game(
      GAME_WIDTH_DEFAULT,
      GAME_HEIGHT_DEFAULT,
      getRendererType(),
      GAME_DIV_ID,
      {
        init: function() {
          Debugger.log('log', 'Initialising app');
          // register CaptionsPlugin
          this.game.springRollCaptionsPlugin = this.game.plugins.add(
            new CaptionsPlugin(this.game, this.game.plugins, appShell.captionsMuted)
          );

          this.game.springRollApplication = springRollApplication;
          this.game.stage.disableVisibilityChange = true;
          this.game.preserveDrawingBuffer = true;
          this.game.input.maxPointers = 1;

          this.game.stage.backgroundColor = GAME_BACKGROUND_COLOR;
          this.game.scale.scaleMode = Phaser.ScaleManager.USER_SCALE;
          this.game.scale.fullScreenScaleMode = Phaser.ScaleManager.USER_SCALE;
          this.game.scale.pageAlignHorizontally = false;
          this.game.scale.pageAlignVertically = false;

          this.game.defaultWidth = GAME_WIDTH_DEFAULT;
          this.game.defaultHeight = GAME_HEIGHT_DEFAULT;
          this.game.offsetWidth = 0;
          this.game.offsetHeight = 0;
          this.game.screenPadding = Math.max(GAME_WIDTH_DEFAULT, GAME_HEIGHT_DEFAULT) * 0.02;

          this.game.aspectController = new AspectController(this.game);
          this.game.sounds = new SoundController({ game: this.game });
          this.game.urls = new AppUrls(this.game);

          this.game.deviceMetric = getDeviceMetric();
        },

        preload: function() {},

        create: function() {
          this.game.onBlur.add(appShell.onBlur, appShell);
          this.game.onFocus.add(appShell.onFocus, appShell);
          this.game.input.onUp.add(appShell.onFocus, appShell);
          this.game.input.onDown.add(appShell.onFocus, appShell);
          this.game.input.onTap.add(appShell.onFocus, appShell);
          this.game.input.onHold.add(appShell.onFocus, appShell);

          // register app states
          Object.keys(STATE_MAP).forEach((key) => {
            this.game.state.add(key, STATE_MAP[key], false);
          });

          // fix for iOS pointerCancel events
          this.game.canvas.addEventListener('MSPointerCancel', (event) => {
            this._pointerCancel(event);
          });
          this.game.canvas.addEventListener('pointercancel', (event) => {
            this._pointerCancel(event);
          });

          this.game.state.start(STATE_BOOT, true, false);
        },
      }
    );

    // Set up custom focus handling.
    this.hidden = undefined;
    this.originalPauseValue = undefined;

    let visibilityChange;

    if (typeof document.hidden !== 'undefined') {
      this.hidden = 'hidden';
      visibilityChange = 'visibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
      this.hidden = 'msHidden';
      visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
      this.hidden = 'webkitHidden';
      visibilityChange = 'webkitvisibilitychange';
    }

    if (typeof document.addEventListener !== 'undefined' && this.hidden !== undefined) {
      document.addEventListener(visibilityChange, () => this.handleVisibilityChange(), false);
    }

    window.addEventListener('onpagehide', () => this.onBlur(), false);
    window.addEventListener('pageshow', () => this.onFocus(), false);
  }

  handleVisibilityChange() {
    if (document[this.hidden]) {
      this.onBlur();
    } else {
      this.onFocus();
    }
  }

  onBlur() {
    // Check if the original pause value isn't undefined that way we don't overwrite
    // it if we get here twice on iOS Safari.
    if (document[this.hidden] && this.originalPauseValue === undefined) {
      this.originalPauseValue = this.game.paused;
      this.pauseGame(true);
    }
  }

  onFocus() {
    if (this.originalPauseValue !== undefined) {
      this.pauseGame(this.originalPauseValue);
      // Set the original paused value to undefined so we can reuse it on the next blur event.
      this.originalPauseValue = undefined;
    }
  }

  pauseGame(pause) {
    this.game.paused = pause;
    this.game.sounds.handleGamePause(pause);
  }

  _pointerCancel(event) {
    if (!this.game.input || !this.game.input.enabled) {
      return;
    }

    event.identifier = event.pointerId;
    if (event.pointerType === 'mouse' || event.pointerType === 0x00000004) {
      this.game.input.mousePointer.stop(event);
    } else {
      this.game.input.stopPointer(event);
    }
  }
}
